import React from 'react';

import { TrialDaysNotification } from './TrialDaysNotification';
import { OverdueInvoicesNotification } from './OverdueInvoicesNotification';
import { SMSUsageLimitNotification } from './SMSUsageLimitNotification';

export function UserActionNotifications() {
  return (
    <>
      <TrialDaysNotification />
      <OverdueInvoicesNotification />
      <SMSUsageLimitNotification />
    </>
  );
}
